export default [

  // *===============================================---*
  // *--------- MAIN DASHBOARD (War Room) -----------*
  // *===============================================---*
  {
    path: '/app/dashboard',
    name: 'app-dashboard',
    component: () => import('@/views/App/Dashboard/WarRoom.vue'),
    meta: { resource: 'VSLBOOSTER', action: 'read', requiresAuth: true },
  },

  // *===============================================---*
  // *--------- USUARIO ---- ---------------------------------------*
  // *===============================================---*
  {
    path: '/admin/overview',
    name: 'admin-overview',
    component: () => import('@/views/App/Administracao/Overview/Dashboard.vue'),
    meta: { resource: 'all', action: 'manage', superAdminOnly: true },
  },
  {
    path: '/admin/observabilidade',
    name: 'admin-observabilidade',
    component: () => import('@/views/App/Administracao/Observability.vue'),
    meta: { resource: 'all', action: 'manage', superAdminOnly: true },
  },
  {
    path: '/admin/usuarios',
    name: 'admin-usuarios',
    component: () => import('@/views/App/Administracao/UsuariosAdmin.vue'),
    meta: { resource: 'all', action: 'manage', superAdminOnly: true },
  },
  // Aliases para manter compatibilidade com links antigos
  {
    path: '/admin/clientes',
    name: 'admin-clientes',
    redirect: { name: 'admin-usuarios', query: { tab: 'clientes' } },
  },
  {
    path: '/apps/usuarios/lista',
    name: 'apps-usuarios-lista',
    redirect: { name: 'admin-usuarios', query: { tab: 'usuarios' } },
  },
  {
    path: '/admin/permissoes',
    name: 'admin-permissoes',
    redirect: { name: 'admin-usuarios', query: { tab: 'permissoes' } },
  },
  {
    path: '/app/webinar-simulator',
    name: 'webinar-simulator',
    component: () => import('@/views/App/WebinarSimulator/Index.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
      action: 'read'
    },
  },
  {
    path: '/admin/configuracoes',
    name: 'admin-configuracoes',
    component: () => import('@/views/App/Administracao/Configuracoes.vue'),
    meta: { resource: 'all', action: 'manage', superAdminOnly: true },
  },
  // Aliases para manter compatibilidade com links antigos
  {
    path: '/admin/aws-config',
    name: 'admin-aws-config',
    redirect: { name: 'admin-configuracoes', query: { tab: 'aws' } },
  },
  {
    path: '/admin/site-scripts',
    name: 'admin-site-scripts',
    redirect: { name: 'admin-configuracoes', query: { tab: 'scripts' } },
  },
  {
    path: '/admin/tag-manager',
    name: 'admin-tag-manager',
    redirect: { name: 'admin-configuracoes', query: { tab: 'tagmanager' } },
  },
  {
    path: '/admin/email-config',
    name: 'admin-email-config',
    redirect: { name: 'admin-configuracoes', query: { tab: 'email' } },
  },
  {
    path: '/admin/webhooks',
    name: 'admin-webhooks',
    redirect: { name: 'admin-configuracoes', query: { tab: 'webhooks' } },
  },
  {
    path: '/app/fale-conosco',
    name: 'fale-conosco',
    component: () => import('@/views/App/FaleConosco/Index.vue'),
    meta: {
      resource: 'all',
      action: 'read',
    },
  },
  {
    path: '/app/heatmap',
    name: 'heatmap',
    component: () => import('@/views/App/Heatmap/Index.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'read',
      requiresAuth: true,
    },
  },
  {
    path: '/app/treinamentos',
    name: 'app-treinamentos',
    component: () => import('@/views/App/Treinamentos/AcademyManager.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'read',
      requiresAuth: true,
    },
  },
  {
    path: '/academia',
    name: 'minha-academia',
    component: () => import('@/views/App/Treinamentos/MyAcademy.vue'),
    meta: {
      layout: 'full',
      resource: 'VSLBOOSTER',
      action: 'read',
      requiresAuth: true,
    },
  },
  {
    path: '/minha-academia',
    redirect: { name: 'minha-academia' },
  },
  {
    path: '/academia/:userId/:studentKey',
    name: 'academy-student',
    component: () => import('@/views/App/Treinamentos/AcademyStudent.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
      requiresAuth: false,
    },
  },
  {
    path: '/auth/callback',
    name: 'YouTubeCallback',
    component: () => import('@/views/auth/YouTubeCallback.vue'),
    meta: {
      title: 'Autenticação YouTube - Callback',
    },
  },
  {
    path: '/apps/users/view/:id',
    name: 'apps-users-view',
    component: () => import('@/views/App/Usuarios/usuarios-view/UsersView.vue'),
  },
  // {
  //   path: '/apps/users/edit/:id',
  //   name: 'apps-users-edit',
  //   component: () => import('@/views/apps/user/users-edit/UsersEdit.vue'),
  // },
  /*

       -------------------------------------------------------------------------------------------------------
       ------------------------------------------PASTAS-------------------------------------------------------
       -------------------------------------------------------------------------------------------------------
       */

  {
    path: '/testepasta',
    name: 'testepasta',
    component: () => import('@/views/App/Pastas/EditarPasta.vue'),
  },
  {
    path: '/FileComponent',
    name: 'FileComponent',
    component: () => import('@/components/FileComponent.vue'),
  },

  /*
       -------------------------------------------------------------------------------------------------------
       ------------------------------------------VIDEOS-------------------------------------------------------
       -------------------------------------------------------------------------------------------------------
       */

  // ── BLOG (Public) ──
  {
    path: '/blog',
    name: 'blog',
    component: () => import('@/views/App/Blog/BlogList.vue'),
    meta: { layout: 'full', resource: 'Auth', action: 'read' },
  },
  {
    path: '/blog/:slug',
    name: 'blog-post',
    component: () => import('@/views/App/Blog/BlogPost.vue'),
    meta: { layout: 'full', resource: 'Auth', action: 'read' },
  },
  // ── AFILIADOS ──
  {
    path: '/afiliados',
    name: 'afiliados',
    component: () => import('@/views/App/Afiliados/AfiliadosCadastro.vue'),
    meta: { layout: 'full', resource: 'Auth', action: 'read' },
  },
  // ── AFILIADOS (Admin) ──
  {
    path: '/admin/afiliados',
    name: 'admin-afiliados',
    component: () => import('@/views/App/Afiliados/AfiliadosAdmin.vue'),
    meta: { resource: 'all', action: 'manage' },
  },
  // ── AI USAGE ──
  {
    path: '/admin/ai-usage',
    name: 'admin-ai-usage',
    component: () => import('@/views/App/Administracao/AiUsage.vue'),
    meta: { resource: 'all', action: 'manage', superAdminOnly: true },
  },
  // ── BLOG (Admin) ──
  {
    path: '/admin/blog',
    name: 'admin-blog',
    component: () => import('@/views/App/Blog/BlogAdmin.vue'),
    meta: { resource: 'all', action: 'manage', superAdminOnly: true },
  },
  {
    path: '/admin/blog/editor/:id?',
    name: 'admin-blog-editor',
    component: () => import('@/views/App/Blog/BlogEditor.vue'),
    meta: { resource: 'all', action: 'manage', superAdminOnly: true },
  },

  {
    path: '/Videos',
    name: 'Meus-Videos',
    component: () => import('@/views/App/Videos/MeusVideos.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
      typeHelperTour: 'meus-videos',
    },
  },
  {
    path: '/videos/pixels/:vslId',
    name: 'video-pixels',
    component: () => import('@/views/App/Videos/PixelConfig.vue'),
    props: true,
    meta: { resource: 'VSLBOOSTER', action: 'vslbooster', requiresAuth: true },
  },
  {
    path: '/adicionarVideos',
    name: 'adicionar-videos',
    component: () => import('@/views/App/Videos/AdicionarVideos.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/Videosdel',
    name: 'videos-lista-legacy',
    component: () => import('@/views/App/Videos/Videos.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /* EDITAR VIDEO */
  {
    path: '/player/:vslId',
    name: 'player',
    component: () => import('@/views/App/Videos/EditarVideo/EditarVideos.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /* CUSTOMIZAÇÂO */

  {
    path: '/player/:vslId/customizacao',
    name: 'customizacao',
    component: () => import('@/views/App/Videos/Customizacao/Customizacao.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/player/:vslId/analytics',
    name: 'analytics',
    component: () => import('@/views/App/Videos/EditarVideo/Analytics.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  /*
      -------------------------------------------------------------------------------------------------------
      ------------------------------------------ESTILO-------------------------------------------------------
      -------------------------------------------------------------------------------------------------------
      */

  {
    path: '/player/:vslId/estilo',
    name: 'estilo',
    component: () => import('@/views/App/Videos/Customizacao/ControleEstilo/Estilo.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/createEstilo',
    name: 'Create-estilo',
    component: () => import('@/views/App/Videos/Customizacao/ControleEstilo/CreateEstilo.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*
     -------------------------------------------------------------------------------------------------------
     ------------------------------------------THUMBNAILS---------------------------------------------------
     -------------------------------------------------------------------------------------------------------
     */

  {
    path: '/player/:vslId/thumbnails',
    name: 'thumbnails',
    component: () => import('@/views/App/Videos/Customizacao/thumb/ThumbNails.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/createthumb/:thumbId',
    name: 'create-thumbnail',
    component: () => import('@/views/App/Videos/Customizacao/thumb/CreateThumb.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  //  {
  //    path: '/thumbnailsInicio',
  //    name: 'thumbnails',
  //    component: () =>import ('@/views/App/Videos/Customizacao/thumb/upload/ThumbnailInicio.vue'),

  //  },

  /*
     -------------------------------------------------------------------------------------------------------
     ------------------------------------------AUTO PLAY HIBRIDO--------------------------------------------
     -------------------------------------------------------------------------------------------------------
     */

  {
    path: '/player/:vslId/AutoPlayHibrido',
    name: 'AutoPlay-Hibrido',
    component: () => import(
      '@/views/App/Videos/Customizacao/Auto-Play-Hibrido/AutoPlayHibrido.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/AutoPlayHibridoCreate',
    name: 'Create-AutoPlay-Hibrido',
    component: () => import(
      '@/views/App/Videos/Customizacao/Auto-Play-Hibrido/CreateAutoPlay.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*
     -------------------------------------------------------------------------------------------------------
     ------------------------------------------CONTINUAR ASSISTINDO ----------------------------------------
     -------------------------------------------------------------------------------------------------------
     */

  {
    path: '/player/:vslId/ContinuarAssistindo',
    name: 'Continuar-Assistindo',
    component: () => import(
      '@/views/App/Videos/Customizacao/Continuaar-Assistindo/ContinuarAssitindo.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/CreateContinuarAssistindo',
    name: 'Create-Continuar-Assistindo',
    component: () => import(
      '@/views/App/Videos/Customizacao/Continuaar-Assistindo/CreateContinuarAssistindo.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*
     -------------------------------------------------------------------------------------------------------
     ------------------------------------------PROGRESSO INTELIGENTE----------------------------------------
     -------------------------------------------------------------------------------------------------------
     */

  {
    path: '/player/:vslId/ProgressoInteligente',
    name: 'Progresso-Inteligente',
    component: () => import(
      '@/views/App/Videos/Customizacao/Progrsso-Inteligente/ProgressoInteligente.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/CreateProgresso',
    name: 'Create-Progresso-Inteligente',
    component: () => import(
      '@/views/App/Videos/Customizacao/Progrsso-Inteligente/CreateProgressoInteligente.vue'
    ),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  {
    path: '/Routerteste',
    name: 'editar-video-legacy',
    component: () => import('@/views/App/Videos/EditarVideo/Editar.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*
      -------------------------------------------------------------------------------------------------------
      ------------------------------------------ BOTÕES DE AÇÕES -------------------------------------------
      -------------------------------------------------------------------------------------------------------
    */
  {
    path: '/player/:vslId/botoes-acoes',
    name: 'botoes-acoes',
    component: () => import('@/views/App/Videos/Customizacao/Botoes-&-Acoes/Index.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },
  /* SEGURANÇA */
  {
    path: '/seguranca',
    name: 'Seguranca',
    component: () => import('@/views/App/Seguranca/Seguranca.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      pageTitle: 'Segurança',
      requiresAuth: true,
    },
  },

  /* TESTE A/B */

  {
    path: '/teste-ab',
    name: 'teste-ab',
    component: () => import('@/views/App/testesAB/TestesAb.vue'),
    meta: {
      pageTitle: 'Teste A/B',
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  /*  DASHABOARD */
  /* CHAT */

  {
    path: '/fluxoMensagem/:id',
    name: 'fluxo',
    component: () => import('@/views/App/Chat/FluxoMensagem.vue'),
    meta: {
      pageTitle: 'Fluxo Perguntas',
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/integracoes',
    name: 'integracoes',
    component: () => import('@/views/App/Integracoes/IntegracaoPage.vue'),
    meta: {
      requiresAuth: true,
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
    },
  },
  {
    path: '/chats',
    name: 'chats',
    component: () => import('@/views/App/Chat/Index.vue'),
    meta: {
      requiresAuth: true,
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
    },
  },
  {
    path: '/dashboardChat',
    name: 'DashboardChat',
    component: () => import('@/views/App/Dashboard/WarRoom.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/teste',
    name: 'teste',
    component: () => import('@/views/App/Chat/Teste.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/design/:id',
    name: 'design',
    component: () => import('@/views/App/Chat/design.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/integreSistema/:id',
    name: 'integreSistema',
    component: () => import('@/views/App/Chat/integreSistema.vue'),
    meta: {
      resource: 'IntegreSistema',
      action: 'integreSistema',
      requiresAuth: true,
    },
  },
  {
    path: '/leads',
    name: 'leads',
    component: () => import('@/views/App/Chat/Leads.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/detalhelead/:id_lead',
    name: 'Detalheleads',
    component: () => import('@/views/App/Chat/detalheLead.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/info',
    name: 'info',
    component: () => import('@/views/App/Chat/Info.vue'),
    meta: {
      resource: 'CHATBOOSTER',
      action: 'chatbooster',
      requiresAuth: true,
    },
  },
  {
    path: '/documentacao',
    name: 'documentacao',
    component: () => import('@/views/App/Documentacao/Index.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
      pageTitle: 'Documentação',
      breadcrumb: [
        { text: 'Documentação', active: true },
      ],
    },
  },
  {
    path: '/configuracoes/chat-suporte',
    name: 'chat-suporte-config',
    redirect: { name: 'admin-configuracoes', query: { tab: 'suporte' } },
    meta: {
      resource: 'all',
      action: 'manage',
      pageTitle: 'Chat de Suporte',
      breadcrumb: [
        { text: 'Administração' },
        { text: 'Chat de Suporte', active: true },
      ],
    },
  },
  /**
     * Rotas Tour Virtual
     */
  {
    path: '/tour-virtual',
    name: 'tour-virtual',
    component: () => import('@/views/App/TourVirtual/Index.vue'),
    meta: {
      resource: 'TOUR_VIRTUAL',
      action: 'manage',
    },
  },
  /**
   * Rotas Pagementos
   */
  {
    path: '/pagamentos',
    name: 'pagamentos',
    redirect: { name: 'admin-usuarios', query: { tab: 'pagamentos' } },
    meta: {
      resource: 'all',
      action: 'manage',
    },
  },

  /**
   * Rota de Checkout Payments
   */
  {
    path: '/payment',
    name: 'payment',
    component: () => import('@/views/App/PaymentView/Index.vue'),
    meta: {
      requiresAuth: false,
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },

  {
    path: '/payment/pix',
    name: 'payment-pix',
    component: () => import('@/views/App/PaymentView/ConfirmePixView.vue'),
    meta: {
      requiresAuth: false,
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },

  {
    path: '/payment/boleto',
    name: 'payment-boleto',
    component: () => import('@/views/App/PaymentView/ConfirmeBoletoView.vue'),
    meta: {
      requiresAuth: false,
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },

  {
    path: '/notificacoes',
    name: 'all-notifications',
    component: () => import('@/views/App/Notificação/Index.vue'),
    meta: {
      resource: 'VSLBOOSTER',
      action: 'vslbooster',
      requiresAuth: true,
    },
  },

  {
    path: '/auth/login/usuario-cliente',
    name: 'auth-login-usuario-cliente',
    component: () => import('@/views/Login/LoginAdminDKP.vue'),
    meta: {
      resource: 'all',
      action: 'manage',
      layout: 'full',
      requiresAuth: true,
    },
  },
]
